var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'font-size-selector font-weight-light d-flex justify-center align-center py-2 px-3 ' +
        (_vm.active ? 'font-size-active' : 'font-size-non-active'),style:(("font-size: " + _vm.font_size + "px")),attrs:{"data-cy":"fontSizeSelector-options"},on:{"click":_vm.setConfigs}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }